export * from 'server/models/VesselPortCallResponse';


// WEBPACK FOOTER //
// ./data/models/VesselPortCallResponse.ts